/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { templateStrings } from "../../../Constant";
import { fetchSettlementSummaryAction } from "../../../redux/action-creators/settlementActionCreator";
import { PageWrapper, TableWrapper } from "../../../shared/layout";
import { BarLoader } from "../../../shared/widgets";
import SettlementCard from "../settlement/SettlementCard";

class PendingSettlement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      selected: [],
      sortBy: "",
      isUpdated: false,
    };
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps) {
    const { selectedDateFilter, cityFilter } = this.props;
    if ((prevProps && prevProps.selectedDateFilter !== selectedDateFilter)
        || (prevProps && prevProps.cityFilter !== cityFilter)) {
      this.getList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  handleAction = (detail) => {
    const { history } = this.props;
    const operatorDetails = {
      operatorId: detail.operatorId,
      operatorName: detail.operatorName,
      date: detail.date,
    };
    history.push("/settlement-view/date-details", operatorDetails);
  };

  /**
   * API call to get vehicles.
   * @param pageNo current page number
   */
  getList = () => {
    const { fetchSettlementSummary, selectedDateFilter, cityFilter } = this.props;
    const { rowsPerPage } = this.state;
    fetchSettlementSummary({
      dateFilter: selectedDateFilter,
      pageSize: rowsPerPage,
      cityFilter: cityFilter.length && cityFilter,
    }, "gridLoader");
  };

  settledDone = () => {
    const { fetchSettlementSummary, selectedDateFilter, operatorId } = this.props;
    const { isUpdated } = this.state;
    this.setState({
      isUpdated: !isUpdated,
    });
    fetchSettlementSummary({
      dateFilter: selectedDateFilter,
      operatorFilter: operatorId,
    }, "gridLoader");
  };

  render() {
    const templateString = templateStrings.dayWiseDueList;
    const {
      gridLoader, content, totalItems, user,
    } = this.props;
    const {
      selected, rowsPerPage, pageNo, sortBy,
    } = this.state;
    const gridStrings = templateStrings[user && user.role && user.role === "Operator" ? "settlementGridItems" : "netDueCardGridItems"];
    return (
      <div>
        <SettlementCard
          data={content}
          isUpdated={this.settledDone}
          isLoading={gridLoader}
          gridStrings={gridStrings}
        />
        <PageWrapper.Header heading="Day wise Dues" hideS>
          <div className="dataTables_length tabWrapper" />
        </PageWrapper.Header>
        <BarLoader scope="header" />
        <TableWrapper
          content={!gridLoader && (content.finalData || [])}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="_id"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateString}
          selectionAllowed={false}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: (state && state.Settlement && state.Settlement.settlementSummary) || {},
    cityFilter: state.Cities.selectedCity,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    gridLoader: (state && state.loadingBar && state.loadingBar.gridLoader),
    totalItems: state?.Settlement?.settlementSummary?.totalCount || 0,
    user: state.Auth.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchSettlementSummary: (params, loaderScope) => {
    dispatch(fetchSettlementSummaryAction(params, loaderScope));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PendingSettlement));
